import graphql__92fa7596d61528fb2d5a from "./__generated__/AnswerThemes_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import ThemesField from "../Form/Field/ThemesField";

const AnswerThemes = props => {
  const { selectedThemeIds, formField } = useFragment(AnswerThemes_answer, props.answer);
  const { fieldName, label, required, hint, hintPosition, maximumThemes, themes, hide } =
    formField;
  const { parent } = props;

  return (
    <ThemesField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      parent={parent}
      hide={hide}
      options={themes}
      maxSelectedOptions={maximumThemes}
      defaultValues={selectedThemeIds}
    />
  );
};

const AnswerThemes_answer = graphql__92fa7596d61528fb2d5a;

export default AnswerThemes;
